import { createFileRoute } from "@tanstack/react-router";
import { PermissionLinkTemplate } from "~/features/permissionLink/PermissionLinkTemplate";
import { requestPushPermissionIfUndetermined } from "~/lib/pushPermissionTracking";

const run = () => requestPushPermissionIfUndetermined("repro_link");

// Repro のポップアップのリンク（carina:///push-permission 等）の受け口
export const Route = createFileRoute("/_authenticated/push-permission")({
  component: () => <PermissionLinkTemplate run={run} />,
});
